import styled from 'styled-components';

type AvatarWrapperProps = {
  circle: boolean;
};

export const AvatarWrapper = styled('div')<AvatarWrapperProps>`
  align-items: center;
  background-color: #34c8b6;
  border-radius: ${(props) => (props.circle ? '50%' : '1rem')};
  box-sizing: border-box;
  color: var(--exact-white);
  display: inline-flex;
  font-size: 12px;
  font-variant: tabular-nums;
  height: 28px;
  justify-content: center;
  list-style: none;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: relative;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  width: 28px;
`;
export const DropdownWrapper = styled('div')`
  box-sizing: border-box;
  width: calc(100vw - 20px);
  max-width: 780px;
  box-shadow: none !important;
`;
export const DropdownContainer = styled('div')`
  background: var(--exact-white);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 1rem 0.3rem;
  margin: 0 auto;
  max-width: 760px;
`;
export const DropdownSelectSection = styled('div')`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  max-width: 760px;
`;
export const DropdownSelect = styled('div')`
  min-width: 150px;
  margin: 0 8px;
  flex: 1;
`;
export const DropdownFilterSection = styled('div')`
  overflow-x: auto;
  overflow-x: overlay;
  display: flex;
  margin: 0 10px;
`;
export const DropdownFilterItem = styled('div')`
  border: 1px #00a796 dashed;
  border-radius: 10px;
  padding: 3px 5px 3px 12px;
  display: inline-block;
  margin: 0 0 0 10px;
  color: #00897b;
  font-family: IRANSans;
`;
export const SearchInputContainer = styled('div')`
  border: var(--exact-white) 1px solid;
  border-radius: 50px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  margin: 0 10px;
  max-width: 760px;
  width: 100%;
`;
export const SearchInput = styled('input')`
  height: 35px !important;
  padding-top: 3px !important;
  border: 0 !important;
  margin: 0 1rem !important;
  box-shadow: none !important;
`;
export const ResultItemSection = styled('div')`
  margin: 0 10px;
  max-height: 300px;
  overflow: auto;
  overflow: overlay;
`;
export const ResultItem = styled('div')`
  display: flex;
  align-items: center;
  padding-top: 1.2rem;
  width: 100%;
`;
export const ItemDescriptionSection = styled('a')`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  color: black;
`;
export const ItemDescriptionTitle = styled('div')`
  font-size: 12px;
`;
export const ItemDescriptionText = styled('div')`
  margin-top: 3px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  max-width: 80%;
  white-space: normal;
`;
